module.exports = __webpack_public_path__ + "img/arrow-left-blue.8f36a51b.svg";